import React from 'react'
import Logo from 'assets/images/GoTackle-Logo.svg'
import PasswordRules from 'components/Auth/PasswordRules'

const AuthCardContainer = ({
  children,
  passwordCheck,
  showPasswordRules,
  topLogoUrl,
  topLogoAlt,
  mainLogoUrl,
  mainLogoAlt,
  hideMainLogo,
}) => {
  const headerLogo = mainLogoUrl || Logo
  const headerAlt = mainLogoUrl ? mainLogoAlt || 'Organization logo' : 'GoTackle icon'

  return (
    <div className="px-6 py-9 max-w-[400px] bg-white rounded-[36px] shadow-lg">
      {topLogoUrl && (
        <div className="pt-3 flex text-center items-center justify-center">
          <img
            src={topLogoUrl}
            alt={topLogoAlt || 'Parent organization logo'}
            className="object-contain h-[28px]"
          />
        </div>
      )}
      {!hideMainLogo && (
        <div
          className={`${
            topLogoUrl ? 'pt-4 pb-9' : 'pb-9 pt-3'
          } max-width-[200] flex text-center items-center justify-center`}
        >
          <img src={headerLogo} alt={headerAlt} className="object-contain h-[39px]" />
        </div>
      )}
      {showPasswordRules && <PasswordRules passwordCheck={passwordCheck} />}
      {children}
    </div>
  )
}

AuthCardContainer.defaultProps = {
  passwordCheck: false,
  showPasswordRules: false,
  topLogoUrl: undefined,
  topLogoAlt: undefined,
  mainLogoUrl: undefined,
  mainLogoAlt: undefined,
  hideMainLogo: false,
}

export default AuthCardContainer
